import { Stack, Typography, Grid2 as Grid } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import EditProfileValue from './EditProfileValue';
import EditProfileLanguages from './EditProfileLanguages';
import EditProfileImage from './EditProfileImage';
import EditProfileSwitch from './EditProfileSwitch';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(2)};
`;

const EditProfileView = () => {
  const [currentFocus, setFocus] = useState('');

  return (
    <Container>
      <Typography variant="h4" align="left" sx={{ pb: 2 }}>
        Profile settings
      </Typography>

      <Grid container gap={2}>
        <Grid>
          <EditProfileImage />
        </Grid>
        <Grid>
          <Stack direction="column" gap={2} width={400}>
            <EditProfileValue
              type="text"
              label="First name"
              propertyName="firstName"
              onFocus={() => setFocus('firstName')}
              abort={currentFocus !== 'firstName'}
            />
            <EditProfileValue
              type="text"
              label="Last name"
              propertyName="lastName"
              onFocus={() => setFocus('lastName')}
              abort={currentFocus !== 'lastName'}
            />
            <EditProfileValue
              type="text"
              label="Employee ID"
              propertyName="employeeId"
              onFocus={() => setFocus('employeeId')}
              abort={currentFocus !== 'employeeId'}
            />
            <EditProfileLanguages
              onFocus={() => setFocus('languages')}
              abort={currentFocus !== 'languages'}
            />
            <EditProfileSwitch
              label="Allow browser notifications"
              propertyName="features.browserNotifications.allowShow"
              onFocus={() => setFocus('browserNotifications')}
              abort={currentFocus !== 'browserNotifications'}
            />
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EditProfileView;
